import {useState} from "react";
import {  ArrowLeftIcon, WarningIcon } from "@chakra-ui/icons";
import { Heading, Tooltip, Flex } from "@chakra-ui/react"
import {map as m,prop as p, compose as C,__,path,addIndex} from "ramda";
import { useSelector } from "react-redux"; 

export const PartHeader = ({props}) => {
  const lang = useSelector(path(["ui","lang"]));
  const [biases_open, setBiasesOpen] = useState(false);

  const biasid = C(m(p("biases")),path(["part","part_bias"]))(props)
  return <Flex align="center" justify="flex-start" gap="2" mb={5}>
    <Heading as={"h2"} size="md">{props.part[lang === "en" ?  "name_eng":"name"]}</Heading>
    <WarningIcon display={biases_open ? "none" : "block"} onClick={() => setBiasesOpen(true)} />
    <Flex display={biases_open ? "block" : "none"}>
      {addIndex(m)((x,n,xs) => <Tooltip key={x.id} label={x[lang === "en" ?  "description_eng":"description"]}>
        {(n===0 ? "": ", ") + x[lang === "en" ?  "name_eng":"name"]}
        </Tooltip>,biasid)}
      <ArrowLeftIcon ml={4} onClick={() => setBiasesOpen(false)} />
    </Flex>
  </Flex>
}